import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import {
  CREATE_CONTRIBUTION,
  LOAD_RENT_AFTER_CONTRIBUTION
} from 'src/store/actions/contractActions';

import StepOne from './StepOne';
import FinalStep from './FinalStep';

const CurrentStep = ({
  activeStep,
  data,
  onNext,
  onBack,
  onSubmit,
  open,
  resetRef,
  hasSaleProductKey
}) => {
  const loading = useSelector(isLoadingSelector([CREATE_CONTRIBUTION.action]));
  const loadingRentAfterContribution = useSelector(
    isLoadingSelector([LOAD_RENT_AFTER_CONTRIBUTION.action])
  );

  if (activeStep === 0) {
    return (
      <StepOne
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        open={open}
        resetRef={resetRef}
      />
    );
  }

  return (
    <FinalStep
      data={data}
      loading={loading}
      loadingRentAfterContribution={loadingRentAfterContribution}
      handleBack={onBack}
      handleSubmit={onSubmit}
      hasSaleProductKey={hasSaleProductKey}
    />
  );
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  data: PropTypes.any.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  resetRef: PropTypes.object.isRequired,
  hasSaleProductKey: PropTypes.object
};

export default CurrentStep;
